export default __webpack_public_path__ + "img/pumpMaintenance.33a665a9.png";